import { defineRule, configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import id from '@vee-validate/i18n/dist/locale/id.json'
import { all } from '@vee-validate/rules'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

Object.entries(all).forEach(([name, rule]) => {
  defineRule(name, rule)
})

defineRule('valid_date', (value) => {
  if (!value) return true

  // Paksa format DD-MM-YYYY
  const date = dayjs(value, 'DD-MM-YYYY', true)

  if (!date.isValid()) {
    return 'Format tanggal tidak valid atau tanggal tidak benar'
  }

  return true
})

defineRule('max_today', (value) => {
  if (!value) return true

  const date = dayjs(value, 'DD-MM-YYYY', true)
  if (!date.isValid()) return 'The date is not valid.'

  const today = dayjs().startOf('day')

  if (date.isAfter(today) || date.isSame(today)) {
    return 'The date cannot be later than or today.'
  }

  return true
})

defineRule('url', value => {
  // Jika field kosong, biarkan valid (gunakan rule 'required' secara terpisah jika wajib)
  if (!value || !value.length) {
    return true;
  }

  // Regex standar untuk URL
  const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

  return pattern.test(value) || 'Format URL tidak valid (contoh: https://google.com)';
});

defineRule('password', (value) => {
  if (!value) return true
  const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/
  if (!regex.test(value)) {
    return 'Password must be at least 8 characters, include uppercase, number, and symbol';
  }

  return true;
})

defineRule('not_before', (value, [startValue, startLabel = 'start time']) => {
  if (!value || !startValue) return true

  return value >= startValue || `This field must not be earlier than ${startLabel}`
})

configure({
  validateOnInput: true,
  generateMessage: localize('id', id),
})
